'use strict'

// A page load that finishes after a newer navigation must not paint.
// Login redirects start one load for the login page and another for the
// destination. Only the newest load may replace what is on screen.

function beginPageLoad (seq) {

  return (Number(seq) || 0) + 1
}

function pageLoadIsCurrent (seq, loadId) {

  return seq === loadId
}

function componentsAfterPageLoad (visible, incoming, seq, loadId) {

  if (!pageLoadIsCurrent(seq, loadId)) return visible

  return incoming
}

module.exports = {
  beginPageLoad,
  pageLoadIsCurrent,
  componentsAfterPageLoad
}
